import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { IconContext } from 'react-icons';
import { FaPhone as Phone } from 'react-icons/fa6';
import { FaCircleQuestion as ChatQuestion } from 'react-icons/fa6';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import config from '../../../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaLinkedIn,
  ExternalLink,
  NamedLink,
} from'../../../../components';

import css from './SectionBnbsHelp.module.css';

const SectionBnbsHelp = props => {
  const { rootClassName, className, intl } = props;
  const { siteFacebookPage, siteInstagramPage, siteLinkedInPage } = config;

  const classes = clsx(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionBnbsHelp.title" />
        <br />
      </div>
      <div className={css.steps}>
        <div className={css.step}>
          <p>
            <FormattedMessage id="SectionBnbsHelp.faq" />
          </p>
          <NamedLink name="FAQPage">
            <IconContext.Provider
              value={{
                size: 70,
                className: css.icon,
                style: { strokeWidth: 2, fill: 'currentColor' },
              }}
            >
              <ChatQuestion />{' '}
            </IconContext.Provider>
          </NamedLink>
        </div>

        <div className={css.step}>
          <p>
            <FormattedMessage id="SectionBnbsHelp.connect" />
          </p>
          <ExternalLink
            key="linkToFacebook"
            href={siteFacebookPage}
            className={css.icon}
            title={intl.formatMessage({ id: 'Footer.goToFacebook' })}
          >
            <IconSocialMediaFacebook className={css.socialIcon} />
          </ExternalLink>
          <ExternalLink
            key="linkToInstagram"
            href={siteInstagramPage}
            className={css.icon}
            title={intl.formatMessage({ id: 'Footer.goToInstagram' })}
          >
            <IconSocialMediaInstagram className={css.socialIcon} />
          </ExternalLink>
          <ExternalLink
            key="linkToLinkedIn"
            href={siteLinkedInPage}
            className={css.icon}
            title={intl.formatMessage({ id: 'Footer.goToLinkedIn' })}
          >
            <IconSocialMediaLinkedIn className={css.socialIcon} />
          </ExternalLink>
        </div>

        <div className={css.step}>
          <p className={css.callUs}>
            <FormattedMessage id="SectionBnbsHelp.call" />
          </p>
          <p className={css.callUs}>
            <a href="tel:+351308810200">
              <FormattedMessage id="SectionBnbsHelp.callNumber" />
            </a>
          </p>
          <p className={css.callUsObs}>
            <FormattedMessage id="SectionBnbsHelp.callUsObs" />
          </p>
          <a href="tel:+351308810200">
            <IconContext.Provider
              value={{
                size: 70,
                className: css.icon,
                style: { strokeWidth: 2, fill: 'currentColor' },
              }}
            >
              <Phone />{' '}
            </IconContext.Provider>
          </a>
        </div>
      </div>
    </div>
  );
};

SectionBnbsHelp.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionBnbsHelp.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionBnbsHelp;
